module.exports = __webpack_public_path__ + "static/media/Gotham-Book.9019ab71.otf";


/*****************
 ** WEBPACK FOOTER
 ** ./src/fonts/Gotham-Book.otf
 ** module id = 1336
 ** module chunks = 0
 **/